export const frameWidth = 720;
export const frameHeight = 576;
